<template>
  <v-container class="mt-4">
    <h2 class="text-h4 mb-4">Тест ролей пользователя</h2>
    
    <v-card class="mt-3">
      <v-card-title>Информация о пользователе</v-card-title>
      <v-card-text>
        <div class="mb-3">
          <strong>Статус аутентификации:</strong> 
          <v-chip 
            :color="isAuthenticated ? 'success' : 'error'"
            size="small"
            class="ml-2"
          >
            {{ isAuthenticated ? 'Авторизован' : 'Не авторизован' }}
          </v-chip>
        </div>
        
        <div class="mb-3">
          <strong>Роли пользователя:</strong>
          <v-list v-if="userRoles.length > 0" density="compact">
            <v-list-item v-for="role in userRoles" :key="role">
              <v-list-item-title>{{ role }}</v-list-item-title>
            </v-list-item>
          </v-list>
          <span v-else class="text-grey">Роли не найдены</span>
        </div>
        
        <div class="mb-3">
          <strong>Является администратором:</strong> 
          <v-chip 
            :color="isAdmin ? 'success' : 'error'"
            size="small"
            class="ml-2"
          >
            {{ isAdmin ? 'Да' : 'Нет' }}
          </v-chip>
        </div>
        
        <div class="mb-3">
          <strong>Информация пользователя:</strong>
          <v-sheet v-if="userInfo" color="grey-lighten-5" class="pa-3 mt-2" rounded>
            <pre>{{ JSON.stringify(userInfo, null, 2) }}</pre>
          </v-sheet>
          <span v-else class="text-grey">Не загружена</span>
        </div>
      </v-card-text>
    </v-card>
    
    <v-card class="mt-3">
      <v-card-title>Проверка доступа</v-card-title>
      <v-card-text>
        <div class="mb-3">
          <v-btn color="primary" class="mr-2" @click="checkRole('admin')">
            Проверить роль Admin
          </v-btn>
          <v-btn color="primary" class="mr-2" @click="checkRole('user')">
            Проверить роль User
          </v-btn>
          <v-btn color="primary" @click="checkRole('moderator')">
            Проверить роль Moderator
          </v-btn>
        </div>
        
        <v-alert 
          v-if="roleCheckResult" 
          :type="roleCheckResult.hasRole ? 'success' : 'warning'"
          class="mt-3"
        >
          {{ roleCheckResult.message }}
        </v-alert>
      </v-card-text>
    </v-card>
    
    <v-card class="mt-3">
      <v-card-title>Действия</v-card-title>
      <v-card-text>
        <v-btn color="info" class="mr-2" @click="refreshUserInfo">
          Обновить информацию
        </v-btn>
        <v-btn color="warning" @click="testTokenRefresh">
          Тест обновления токена
        </v-btn>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import apiClient from '@/apiClient';

export default {
  name: 'TestRoles',
  data() {
    return {
      roleCheckResult: null
    };
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['isAuthenticated', 'userRoles', 'isAdmin', 'hasRole'])
  },
  methods: {
    checkRole(role) {
      const hasRole = this.hasRole(role);
      this.roleCheckResult = {
        hasRole,
        message: hasRole 
          ? `✓ У вас есть роль "${role}"` 
          : `✗ У вас нет роли "${role}"`
      };
    },
    
    async refreshUserInfo() {
      try {
        const response = await apiClient.get('/users/me');
        if (response.data.roles) {
          const roleNames = response.data.roles.map(role => role.name);
          this.$store.commit('setUserRoles', roleNames);
        }
        this.$store.commit('setUserInfo', response.data);
        this.$emit('show-message', 'Информация обновлена', false);
      } catch (error) {
        this.$emit('show-message', 'Ошибка обновления информации', true);
      }
    },
    
    async testTokenRefresh() {
      try {
        // Force a token refresh
        await apiClient.post('/auth/refresh');
        this.$emit('show-message', 'Токен успешно обновлен', false);
        
        // Refresh user info after token refresh
        await this.refreshUserInfo();
      } catch (error) {
        this.$emit('show-message', 'Ошибка обновления токена', true);
      }
    }
  },
  mounted() {
    if (this.isAuthenticated && !this.userInfo) {
      this.refreshUserInfo();
    }
  }
};
</script>

<style scoped>
pre {
  font-size: 0.875rem;
  margin: 0;
}
</style>